import type { MessageChannelType } from "@whatslly/types/instant-messaging/messagesEmitter";
import type { TuvisIconNamesType } from "@whatslly/types/UI-V2/BaseElements/Svg/TuvisIconNamesType";

const CHANNEL_TYPE_ICONS: Record<MessageChannelType, TuvisIconNamesType> = {
  androidNativeRecording: "call_recording",
  imessage: "imessage-blank-logo",
  sms: "sms",
  telegram: "telegram",
  twilioVoip: "voice",
  whatsAppApi: "whatsapp-business-api",
  whatsAppWeb: "whatsapp",
  line: "line",
  signal: "signal",
  "teams-archive": "microsoft-teams",
  "discord-archive": "messages-platform",
};

export const getChannelTypeToIcon = (channelType?: string): TuvisIconNamesType | undefined => CHANNEL_TYPE_ICONS[channelType as MessageChannelType];
